export default "__VITE_ASSET__3f6b5a83__"